/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OAuthProviderParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['name', codecString],
    ['platform', /* #__PURE__ */ parsers.exactly('github', 'gitlab')],
    ['baseUrl', codecString, 'base_url'],
]);
export class OAuthProvider extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OAuthProviderParser.decode(input).map(res => new OAuthProvider(res));
    }
    static unsafeDecode(input) {
        return OAuthProvider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OAuthProviderParser.encode(data);
    }
    static schema() {
        return OAuthProviderParser.schema();
    }
}
